import { render, staticRenderFns } from "./DianJinItem.vue?vue&type=template&id=15bc56a4&scoped=true&"
import script from "./DianJinItem.vue?vue&type=script&lang=js&"
export * from "./DianJinItem.vue?vue&type=script&lang=js&"
import style0 from "./DianJinItem.vue?vue&type=style&index=0&id=15bc56a4&scoped=true&lang=scss&"
import style1 from "./DianJinItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc56a4",
  null
  
)

export default component.exports